import { render, staticRenderFns } from "./ShippingFunction.vue?vue&type=template&id=19575f30&"
import script from "./ShippingFunction.vue?vue&type=script&lang=js&"
export * from "./ShippingFunction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports